<template>
    <div
        class="fixed inset-0 z-[1002] flex items-center justify-center bg-black/50"
    >
        <div class="relative mx-4 flex max-h-[96vh] w-full max-w-[660px] items-center justify-center overflow-y-auto rounded-[20px] bg-white">
            <!-- 关闭按钮 -->
            <button
                class="absolute right-6 top-6 z-10 flex h-8 w-8 items-center justify-center rounded-full text-[#495973] transition-colors hover:text-[#495973]"
                @click="onClose"
            >
                <PtIcon icon="SolidCloseMedium" class="text-xl" />
            </button>

            <!-- UpgradeDialog 内容 -->
            <UpgradeDialog :role="role" :on-close="onClose" :event-detail="eventDetail" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { PtIcon } from 'patsnap-biz';
import '@patsnap-ui/icon/assets/solid/CloseMedium.svg';
import UpgradeDialog from './UpgradeDialog.vue';
import { useTrack } from '../../composables/use-track';
import { onMounted } from 'vue';
import _ from 'lodash';

interface Props {
    callback: () => void;
    role?: 'personal_basic' | 'personal_pro';
    eventDetail?: Record<string, any>;
}

const props = withDefaults(defineProps<Props>(), {
    role: 'personal_basic',
});

const track = useTrack();

onMounted(() => {
    const agentName = _.get(props.eventDetail, 'agents');

    track({
        eventType: 'SS EUREKA UPGRADE PAGE',
        sourceType: 'upgrade_trigger',
        moduleType: 'LS',
        eventDetail: {
            product_line: 'eureka_ls',
            agent_name: agentName?.join(','),
            ...(props.eventDetail || {}),
        },
    })
})

function onClose() {
    props.callback();
}
</script>

<style scoped>
.modal-enter-active,
.modal-leave-active {
    transition: opacity 0.3s ease;
}

.modal-enter-from,
.modal-leave-to {
    opacity: 0;
}

.modal-enter-active .relative,
.modal-leave-active .relative {
    transition: transform 0.3s ease;
}

.modal-enter-from .relative,
.modal-leave-to .relative {
    transform: scale(0.95);
}
</style>
